/**
 * WelcomeHeader - Branded header section for the StartPage
 *
 * Displays Jam SQL Studio logo, product name, and version.
 * Compact design with logo image.
 */

// App version injected at build time from package.json via Vite define
declare const __APP_VERSION__: string;

export type WelcomeHeaderProps = {
  className?: string;
};

export function WelcomeHeader({ className }: WelcomeHeaderProps) {
  return (
    <div
      className={`flex items-center gap-4 py-4 ${className ?? ''}`}
      data-testid="welcome-header"
    >
      {/* Logo - use relative path that works with Electron's loadFile() */}
      <img
        src="./logo.png"
        alt="Jam SQL Studio"
        className="h-12 w-12 object-contain"
      />

      {/* Text content */}
      <div className="flex flex-col">
        <div className="flex items-center gap-2">
          <h1
            className="text-xl font-bold tracking-tight text-foreground"
            data-testid="welcome-header-title"
          >
            Jam SQL Studio
          </h1>
          <span
            className="inline-flex items-center rounded-full border border-border/50 bg-muted/50
                       px-2 py-0.5 text-xs font-medium text-muted-foreground"
            data-testid="welcome-header-version"
          >
            v{__APP_VERSION__}
          </span>
        </div>
        <p className="text-sm text-muted-foreground">
          Manage your database connections and explore your data
        </p>
      </div>
    </div>
  );
}
